import { Component } from '@verndale/core';
import debounce from 'lodash.debounce';
import { isDevice, getScrollbarWidth } from '../helpers';
import Swiper from 'swiper/core';
import { addGenericSwiperNav } from '../helpers/slider-nav';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $cards: this.el._$$('.content-card'),
      $cardsContainer: this.el._$('.cards-slider__cards-container'),
      $firstCard: this.el._$('.content-card'),
      $image: this.el.parentElement._$('.cards-slider__image'),
      $pager: this.el._$('.slider-nav__pager'),
      $nav: this.el._$('.slider-nav'),
      $wrapper: this.el._$('.swiper-wrapper'),
      $primaryContacts: document._$('.primary-contacts')
    };

    this.mobileStyleApplied = true;
    this.secondary = this.el.parentElement.classList.contains(
      'cards-slider--secondary'
    );
    this.additional = this.el.parentElement.classList.contains(
      'cards-slider--additional'
    );
    this.primary = !this.secondary && !this.additional;
    this.isRecentlyViewed = this.el.parentElement.classList.contains(
      'cards-slider--recently-viewed'
    );
    this.slidesNumber = this.dom.$cards.length;

    this.dashboard = this.el.parentElement.classList.contains(
      'cards-slider--dashboard'
    );
    if (!this.dashboard) {
      this.el.style.width = `calc(100vw - ${getScrollbarWidth() / 2}px)`;
    }
    if (document._$('main')) document._$('main').style.overflowX = 'hidden';

    this.handleWindowResize = debounce(() => {
      this.updateLayout();
    }, 250);

    this.createFadeout();
    this.updateLayout();
  }

  addListeners() {
    window._on('resize', this.handleWindowResize.bind(this));

    // in some cases, we may need ENG adding cards after init
    if (this.isRecentlyViewed) {
      this.observer = new MutationObserver(() => {
        if (this.el._$$('.content-card').length !== this.slidesNumber)
          this.updateLayout();
      });
      this.observer.observe(this.dom.$wrapper, { childList: true });
    }
  }

  createFadeout() {
    if (!this.el._$('.cards-slider__fadeout')) {
      const fadeRight = document.createElement('div');
      const fadeLeft = document.createElement('div');
      fadeRight.classList.add('cards-slider__fadeout');
      fadeLeft.classList.add(
        'cards-slider__fadeout',
        'cards-slider__fadeout--left'
      );
      this.el.appendChild(fadeRight);
      this.el.appendChild(fadeLeft);
    }
  }

  // workaround for slider pagination - avoid last slides staying off layout
  fillWithBlank(remainder) {
    this.removeBlank();

    const sliderCards = this.dom.$cards;
    const totalCards = sliderCards.length;
    const itemsPerPage = 4;
    const pages = Math.ceil(totalCards / itemsPerPage);
    if (this.dashboard) {
      if (
        this.dom.$wrapper.offsetWidth >
        sliderCards[0].offsetWidth * totalCards + 20 * totalCards - 1
      ) {
        return;
      }
    }
    if (!remainder) remainder = itemsPerPage * pages - totalCards;

    for(let i = 0; i < remainder; i++) {
      const cardClone = this.dom.$primaryContacts
        ? this.dom.$primaryContacts._$('.contact-card').cloneNode(true)
        : this.el._$('.swiper-slide').cloneNode(true);
      cardClone.style.display = 'flex';
      cardClone.style.visibility = 'hidden';
      cardClone.classList.add('blank-slide');
      cardClone.innerHTML = '';
      this.dom.$wrapper.appendChild(cardClone);
    }

    this.dom.$blankSlides = this.dom.$wrapper._$$('.blank-slide');
  }

  removeBlank() {
    if (this.dom.$blankSlides) {
      this.dom.$blankSlides.forEach(el => el.remove());
      this.dom.$blankSlides = null;
    }
  }

  initSlider() {
    if (!this.dom.$firstCard) return;

    const { $cardsContainer, $pager } = this.dom;
    this.showMobileNav = this.dashboard
      ? this.dom.$cards[0].offsetWidth * 2 > this.el.offsetWidth
      : window.matchMedia(
          `(max-width: ${this.dom.$firstCard.offsetWidth * 1.5}px)`
      ).matches;

    this.showMobileNav ? this.removeBlank() : this.fillWithBlank(1);

    const renderCustom = (_, current) => {
      let str = '';

      if (this.showMobileNav) {
        str = `${current} / ${this.slidesNumber}`;
      } else {
        let pageMax = _.activeIndex + _.params.slidesPerGroup;
        if (pageMax > this.slidesNumber) pageMax = this.slidesNumber;
        str = `${_.activeIndex + 1} - ${pageMax} / ${this.slidesNumber}`;
      }

      return str;
    };

    new Swiper($cardsContainer, {
      loopFillGroupWithBlank: true,
      lazy: false,
      slidesPerView: 'auto',
      slidesPerGroup: 4,
      spaceBetween: 20,
      ...addGenericSwiperNav(this.el),
      pagination: {
        type: 'custom',
        el: $pager,
        modifierClass: '',
        renderCustom
      },
      breakpoints: {
        320: {
          slidesPerGroup: 1
        },
        480: {
          slidesPerGroup: 2
        },
        760: {
          slidesPerGroup: this.dashboard ? 1 : 3
        },
        1024: {
          slidesPerGroup: this.dashboard ? 2 : 4
        },
        1240: {
          slidesPerGroup: this.dashboard ? 3 : 4
        }
      }
    });
  }

  updateLayout() {
    if (this.isRecentlyViewed) {
      this.dom.$firstCard = this.el._$('.content-card');
      this.dom.$cards = this.el._$$('.content-card');
      this.slidesNumber = this.dom.$cards.length;
    }

    if (!this.dashboard) {
      this.mobileStyleApplied =
        window
          .getComputedStyle(this.el.parentElement._$('.cards-slider__heading'))
          .getPropertyValue('font-size')
          .split('px')[0] < 48;

      let navVisibility = 'visible';

      if (isDevice() || this.mobileStyleApplied) {
        this.dom.$cards.length > 1
          ? (navVisibility = 'visible')
          : (navVisibility = 'hidden');
      } else {
        this.dom.$cards.length > 4
          ? (navVisibility = 'visible')
          : (navVisibility = 'hidden');
      }

      this.dom.$nav.style.visibility = navVisibility;

      if (this.slidesNumber <= 4 && this.slidesNumber >= 1) {
        this.dom.$wrapper.classList.add('swiper-wrapper--no-grow'); // don't distribute, just stack all cards to the right
      }
    } else {
      const navVisible =
        this.slidesNumber * this.dom.$cards[0].offsetWidth >
        this.el.offsetWidth;

      this.dom.$nav.style.visibility = navVisible ? 'visible' : 'hidden';
      this.dom.$nav.style.maxBlockSize = navVisible ? 'unset' : '0';
    }

    this.resizeImage();
    this.initSlider();
  }

  resizeImage() {
    if (
      !this.dom.$image ||
      isDevice() ||
      this.mobileStyleApplied ||
      !this.secondary
    )
      return;

    const imgWidth = Math.floor(
      window.innerWidth - (window.innerWidth - 1200) / 2
    );
    this.dom.$image.style.width = `${imgWidth}px`;
  }
}

export default Module;
